import axios from "axios";

export default axios.create({
  baseURL: "https://enterprisezk-circuit-service.onrender.com",
  headers: {
    "Content-type": "application/json"
  }
});